<template>
    <div class="stats-container">
      <div class="stats-content-horizontal">
        <span class="stats-value">{{ formattedDisplayValue }}</span>
        <span class="stats-title">{{ title }}</span>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: 'Stats',
    props: {
      title: {
        type: String,
        required: true,
      },
      value: {
        type: [String, Number],
        required: true,
      },
    },
    data() {
      return {
        displayValue: 0,
        intervalId: null,
      };
    },
    mounted() {
      this.animateValue(0, this.value);
    },
    beforeUnmount() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
    computed: {
      formattedDisplayValue() {
        return this.formatNumber(Math.round(this.displayValue));
      },
      dynamicFontSize() {
        const length = String(Math.round(this.displayValue)).length;
        if (length > 8) {
          return '18px';
        } else if (length > 6) {
          return '24px';
        } else if (length > 4) {
          return '32px';
        }
        return '38px';
      },
    },
    methods: {
      formatNumber(value) {
        return new Intl.NumberFormat('es-CO', {
          maximumFractionDigits: 0,
          minimumFractionDigits: 0,
        }).format(value);
      },
      animateValue(start, end) {
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
        start = Number(start);
        end = Number(end);
        const duration = Math.min(1000 + Math.log10(end) * 200, 2000);
        const frameRate = 30;
        const totalFrames = Math.round((duration / 1000) * frameRate);
        let currentFrame = 0;
        const increment = (end - start) / totalFrames;
        this.displayValue = start;
        this.intervalId = setInterval(() => {
          currentFrame++;
          this.displayValue = start + increment * currentFrame;
          if (currentFrame >= totalFrames) {
            clearInterval(this.intervalId);
            this.displayValue = end;
          }
        }, duration / totalFrames);
      },
    },
    watch: {
      value: {
        handler(newValue) {
          this.animateValue(this.displayValue, newValue);
        },
      },
    },
  };
  </script>

  <style scoped>
  .stats-container {
    width: 100%;
    min-height: 70px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-radius: 8px;
    padding: 8px;
  }

  .stats-content-horizontal {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    gap: 8px;
  }

  .stats-value {
    color: #000;
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    font-size: 2.5rem;
    line-height: 1;
    text-align: left;
  }

  .stats-title {
    color: #1b212e;
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.2;
    text-align: left;
    white-space: pre-line;
    overflow-wrap: break-word;
    max-width: 100%;
  }

  @media (max-width: 1200px) {
    .stats-container {
      min-height: 65px;
      padding: 6px 10px;
    }
    .stats-value {
      font-size: 2.5rem;
    }
  }

  @media (max-width: 992px) {
    .stats-container {
      margin-bottom: 0.5rem;
      min-height: 60px;
    }
    .stats-value {
      font-size: 2rem;
    }
  }

  @media (max-width: 768px) {
    .stats-container {
      min-height: 55px;
      padding: 5px 8px;
    }
    .stats-value {
      font-size: 1.7rem;
    }
    .stats-title {
      font-size: 0.95rem;
    }
  }

  @media (max-width: 576px) {
    .stats-container {
      min-height: 50px;
      padding: 4px 6px;
    }
    .stats-value {
      font-size: 1.5rem;
    }
    .stats-title {
      font-size: 0.85rem;
    }
  }
  </style>
